// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ekNl","content":"styles_content__1XQ--","row":"styles_row__2m7a1","footer":"styles_footer__1YYsm","phraseLength":"styles_phraseLength__OjkDT"};